// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__3gICw","list":"Nav_list__13BMF"};